import { render, staticRenderFns } from "./inputv2.vue?vue&type=template&id=3b4d45bb&scoped=true"
import script from "./inputv2.vue?vue&type=script&lang=js"
export * from "./inputv2.vue?vue&type=script&lang=js"
import style0 from "./inputv2.vue?vue&type=style&index=0&id=3b4d45bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d45bb",
  null
  
)

export default component.exports